import { ButtonLink, Header, Stack, StackItem } from '@asgard/ui-library';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { Link } from 'react-scroll';
import { getPublicPath } from 'utils/paths';
import * as SP from '../../HrAsAServicePage.styled';
import * as S from './Help.styled';

export const Help: React.FC = () => {
  const { t } = useI18n('hr-as-a-service');
  const features = [
    {
      items: 6
    },
    {
      items: 6
    },
    {
      items: 4
    },
    {
      items: 4
    }
  ];
  return (
    <S.Root>
      <SP.Container>
        <S.Intro>
          <Header as="h3" size="5xl" editorial>
            <HtmlTrans
              ns="hr-as-a-service"
              i18nKey={'hr-as-a-service.help.title'}
            />
          </Header>

          <HtmlTrans
            ns="hr-as-a-service"
            i18nKey={'hr-as-a-service.help.desc'}
          />
        </S.Intro>

        <S.Features>
          {features.map((feature, index) => (
            <S.Feature key={index}>
              <Stack>
                <StackItem>
                  <Header as="h4" size="4xl" editorial>
                    <HtmlTrans
                      ns="hr-as-a-service"
                      i18nKey={`hr-as-a-service.help.feature${index + 1}.title`}
                    />
                  </Header>

                  <HtmlTrans
                    ns="hr-as-a-service"
                    i18nKey={`hr-as-a-service.help.feature${index + 1}.desc`}
                  />

                  <Link to="hrForm" href="#hrForm">
                    <ButtonLink
                      variant="hard"
                      schema="brand2"
                      size="xs"
                      endIcon={faArrowRight}
                      label={t('hr-as-a-service.help.item-cta')}
                      href="#hrForm"
                    />
                  </Link>
                </StackItem>
                <StackItem className="items">
                  <ul>
                    {Array.from(Array(feature.items).keys()).map((_, j) => (
                      <li key={j}>
                        <img
                          src={getPublicPath(
                            `/images/hr-as-a-service/item${index + 1}.svg`
                          )}
                        />
                        <HtmlTrans
                          ns="hr-as-a-service"
                          i18nKey={`hr-as-a-service.help.feature${
                            index + 1
                          }.item${j + 1}`}
                        />
                      </li>
                    ))}
                  </ul>
                </StackItem>
              </Stack>
            </S.Feature>
          ))}
        </S.Features>

        <S.CTA>
          <Link to="hrForm" href="#hrForm">
            <ButtonLink
              variant="hard"
              schema="brand2"
              startIcon={faCheckCircle}
              label={t('hr-as-a-service.hero.cta')}
              href="#hrForm"
            />
          </Link>
        </S.CTA>
      </SP.Container>
    </S.Root>
  );
};
